import { render, staticRenderFns } from "./SysInfoItemDialog.vue?vue&type=template&id=fdf639be&"
import script from "./SysInfoItemDialog.vue?vue&type=script&lang=js&"
export * from "./SysInfoItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports